<template>
  <v-container class="product-detail-page">
    <!-- 产品预售信息 -->
    <section class="product-hero">
      <div class="container">
        <h1 class="page-title">{{ $t('productDetail.preOrder') }}</h1>

        <div class="product-main">
          <div class="product-image">
            <img width="300" height="300" :src="product.image" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" decoding="async" fetchpriority="high" :srcset="product.srcset" sizes="(max-width: 300px) 100vw, 300px" :alt="product.name">
          </div>

          <div class="product-info">
            <h2>{{ product.name }}</h2>
            <div class="product-price">
              <span class="original-price">$ {{ product.regularPrice }}</span>
              <span class="sale-price">$ {{ product.salePrice }}</span>
            </div>

            <div class="product-specs">
              <ul>
                <li v-for="attribute in product.attributes" :key="attribute.name">
                  <span class="spec-label">{{ attribute.name }}:</span>
                  <span class="spec-value">{{ attribute.value }}</span>
                </li>
              </ul>
            </div>

            <div class="product-actions">
              <div class="total-price">
                <span style="color:#333;font-weight:bold">{{ $t('productDetail.totalAmount') }}:</span>
                <span class="price">$ {{ totalPrice }}</span>
              </div>
              <div class="quantity">
                <div class="quantity-control">
                  <button @click="updateQuantity(-1)" class="minus">-</button>
                  <input type="number" v-model.number="quantity" min="1" />
                  <button @click="updateQuantity(1)" class="plus">+</button>
                </div>
              </div>
            </div>
            <button class="buy-now" @click="buyNow">{{ $t('productDetail.buy') }}</button>
          </div>
        </div>
      </div>
    </section>
    <section class="product-description">
      <div class="container">
        <div class="product-description-content">
          <section v-html="product.description"></section>
        </div>
      </div>
    </section>
  </v-container>
</template>

<script>
import { fetchFeaturedProduct } from '@/api/apiService';
// import Toast from '@/utils/toast';
export default {
  data() {
    return {
      product: {
        id: 0,
        name: '',
        image: '',
        images: [],
        regularPrice: 0,
        salePrice: 0,
        attributes: [],
        description: '',
        srcset: '',
      },
      quantity: 1,
    };
  },
  computed: {
    totalPrice() {
      return (this.product.salePrice * this.quantity).toFixed(2);
    }
  },
  watch:{
    '$i18n.locale':{
      handler(newVal){
        console.log(newVal, 'newVal');
        this.fetchProductData();
      }
    }
  },
  mounted() {
    this.fetchProductData();
  },
  methods: {
    fetchProductData() {
      // Fetch product data from WordPress REST API
      fetchFeaturedProduct().then(response => {
        const productData = response;
        this.product = {
          id: productData.id,
          name: productData.name,
          image: productData.image,
          images: productData.images,
          regularPrice: productData.regular_price,
          salePrice: productData.sale_price,
          attributes: Object.values(productData.attributes).map(attr => ({
            name: attr.name,
            value: attr.options.join(', '),
          })),
          description: productData.description,
          srcset: productData.srcset,
        };
      });
    },
    updateQuantity(amount) {
      this.quantity = Math.max(1, this.quantity + amount);
    },
    buyNow() {
        localStorage.setItem('product_'+ this.product.id, JSON.stringify(this.product));
        const cart = localStorage.getItem('cart');
        if(cart){
            const cartItems = JSON.parse(cart);
            const cartItem = cartItems.findIndex(item => item.product_id === this.product.id);
            if(cartItem >= 0){
                cartItems[cartItem].quantity += this.quantity;
            }else{
                cartItems.push({
                    product_id: this.product.id,
                    quantity: this.quantity,
                });
            }
            localStorage.setItem('cart', JSON.stringify(cartItems));
        }else{
            localStorage.setItem('cart', JSON.stringify([{
                product_id: this.product.id,
                quantity: this.quantity,
            }]));
        }
    //   addToCart(this.product.id, this.quantity)
    //   .then(response => {
    //     // Redirect to cart page after adding to cart
    //     if(response.success){
          this.$router.push({ name: 'CartPage' });
    //     }else{
    //         Toast.showToast('添加到購物車失敗');
    //     }
    //   })
    //   .catch(error => {
    //     console.error('Error adding to cart:', error);
    //   });
    },
  },
};
</script>

<style>
.container {
    max-width: 1200px;
    margin: 0 auto;
}
.product-description {
    margin-bottom: 140px;
}
/* 产品预售区域 */
.page-title {
    font-size: 48px;
    background: linear-gradient(273deg, #055321 68.43%, #77A792 101.14%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 20px;
    text-align: left;
}
.product-features h2:first-child  {
    font-size: 36px;
    color: #006400;
    margin-bottom: 20px;
}
.product-info h2{
    font-size: 24px;
    color: #006400;
    margin-bottom: 20px;
}

.product-main {
    display: flex;
    gap: 20px;
    align-items: flex-start;
}

.product-image {
    flex: 5;
    height: auto;
}

.product-info {
    flex: 5;
}

.product-price {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.original-price {
    font-size: 18px;
    color: #ff4444;
    text-decoration: line-through;
}

.sale-price {
    font-size: 18px;
    color: #fff;
    background-color: #ff4444;
    padding: 5px 10px;
    border-radius: 5px;
    font-weight: bold;
}

.product-specs {
    /* margin: 20px 0; */
    border-top: 1px solid #77A792;
    border-bottom: 1px solid #77A792;
    padding: 10px 0;
}

.product-specs ul {
    list-style: none;
    padding: 0;
}


.product-specs li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    color: #333;
}


.spec-label {
    flex: 1;
    text-align: left;
    font-weight: bold;
}

.spec-value {
    flex: 1;
    text-align: left;
    color: #006400;
}

.product-specs .spec-label {
    text-align: left;
}

.product-specs .spec-value {
    text-align: left;
    color: #006400;
}
.product-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.total-price {
    font-size: 18px;
    color: #E53835;
    padding: 5px 10px;
    border-radius: 5px;
    font-weight: 700;
    display: flex;
    justify-content: flex-start;
    width: 200px;
}
.quantity-control {
    display: flex;
    align-items: flex-end;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-left: 20px;
}

.quantity-control button {
    width: 36px;
    height: 36px;
    border: none;
    background: none;
    cursor: pointer;
}

.quantity-control input {
    width: 60px;
    height: 36px;
    border: none;
    text-align: center;
}
.buy-now {
    display: block;
    width: 100%;
    margin-top: 20px;
    padding: 10px 20px;
    background: #ff4444;
    color: #fff;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
}

.buy-now:hover {
    opacity: 0.9;
}

/* 产品特性区域 */

/* 响应式设计 */
@media (max-width: 768px) {
    .product-main {
        flex-direction: column;
        gap: 30px;
    }

    .page-title {
        font-size: 24px;
    }

    .section-title {
        font-size: 22px;
    }
}

.features-section {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.feature-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: nowrap;
}

.feature-item:nth-child(even) {
    flex-direction: row;
}

.feature-item:nth-child(odd) {
    flex-direction: row-reverse;
}

.feature-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #055321;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.feature-item:nth-child(even) .feature-content {
    text-align: left;
}

.feature-item:nth-child(odd) .feature-content {
    text-align: right;
}

.feature-item:nth-child(odd) .feature-image {
    justify-content: flex-start; /* 左侧靠左 */
}

.feature-item:nth-child(even) .feature-image {
    justify-content: flex-end; /* 右侧靠右 */
}
.feature-image {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.feature-image img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  main {
    padding: 0 !important;
  }
    .feature-item {
        flex-direction: column;
        text-align: center;
    }

    .feature-item:nth-child(even) {
        flex-direction: column;
    }

    .feature-content {
        white-space: normal;
    }
}
</style> 